import Action from '../actions' 

var initialState = {
    locale: "en"
}

function langReducer(state = initialState, action) {
    switch (action.type) {
        case Action.CHANGE_LANG:
            return {
                ...state,
                locale: action.locale
            }
        default:
            return state
    }
}

export default langReducer;